export default "__VITE_ASSET__b93e7751__"